export default "__VITE_ASSET__CdGSSboN__"